export default {
  'clocks': [
    'clock0900_1100',
    'clock1100_1300',
    'clock1400_1600',
    'clock1600_1800'
  ],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage',
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode'
    ],
    'consulting': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'offersInvestment': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ],
    'customer_serviceBank': [
      'Company',
      'RequestTopic'
    ],
    'investor_relations': [
      'Company',
      'RequestTopic'
    ],
    'cooperation': [
      'Company',
      'RequestTopic',
      'PostalCode'
    ]
  }
}
